<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="main">
      <navMenu :active="active"></navMenu>
      <div class="content" v-loading.fullscreen.lock="loading">
        <div class="go-back" @click="goBack">返回</div>
        <div class="main-title">{{ formData.id ? "编辑产品" : "添加产品" }}</div>
        <!-- <div class="create-title">基本信息</div> -->
        <!-- 表单信息 -->
        <el-form ref="formData"  label-position="top" class="form" :model="formData" label-width="140px"  :rules="formRules">

                 <el-form-item label="企业名称（中文）">
                    <el-input v-model="userdata.name_cn" clearable placeholder="请输入企业名称（中文）"  :disabled="true"/>
                </el-form-item>
                <el-form-item label="产品分类" prop="types">
                     <el-cascader :options="menuOptions" v-model="formData.types" clearable :props="optionProps" style="width:100%"></el-cascader>
                </el-form-item>
               
                <el-form-item label="产品名称（中文）" prop="name_cn">
                    <el-input v-model="formData.name_cn" clearable placeholder="请输入产品名称（中文）" />
                </el-form-item>
                <el-form-item label="产品名称（英文）" prop="name_en">
                    <el-input v-model="formData.name_en" clearable placeholder="请输入产品名称（英文）" />
                </el-form-item>
                <el-form-item label="型号" prop="model">
                    <el-input v-model="formData.model" clearable placeholder="请输入型号" />
                </el-form-item>
                <el-form-item label="制造商" prop="manufacturer">
                    <el-input v-model="formData.manufacturer" clearable placeholder="请输入制造商" />
                </el-form-item>
                <el-form-item label="国家地区" prop="country_area">
                        <el-cascader style="width: 100%;" v-model="formData.country_area" :options="locationdata" clearable></el-cascader>
                    <!--<el-input v-model="formData.country_area" clearable placeholder="请输入国家地区" />-->
                </el-form-item>
              
              
                <el-form-item label="展示类别" prop="show_type">
                   <el-radio-group v-model="formData.show_type" placeholder="请选择展示类别">
                        <el-radio 
                            v-for="(item, index) in show_type"
                            :key="index"
                            :label="item.value"
                        >
                            {{ item.name }}
                        </el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="销售联系人" prop="contacts">
                    <el-input v-model="formData.contacts" clearable placeholder="请输入销售联系人" />
                </el-form-item>
                <el-form-item label="电话" prop="mobile">
                    <el-input v-model="formData.mobile" clearable placeholder="请输入电话" />
                </el-form-item>
                <el-form-item label="Email" prop="email">
                    <el-input v-model="formData.email" clearable placeholder="请输入Email" />
                </el-form-item>
                <el-form-item label="产品用途" prop="purpose">
                    <el-input v-model="formData.purpose"  maxlength="600"  show-word-limit type="textarea" rows="4"   clearable placeholder="请输入产品用途" />
                </el-form-item>
                <el-form-item label="产品性能指标" prop="performance">
                    <el-input  v-model="formData.performance"  maxlength="600"  show-word-limit type="textarea" rows="4"   clearable placeholder="请输入产品性能指标" />
                </el-form-item>
                <el-form-item label="产品图片" prop="imgs">
                    <div  class="image" v-if="formData.imgs">
                        <el-image :src="$imgUrl+formData.imgs"></el-image>
                        <div class="upload-span">
                            <span class="upload-icon" @click.stop="handlePictureCardPreview($imgUrl+formData.imgs)"><i class="el-icon-zoom-in"></i></span>
                            <span class="upload-icon" @click.stop="handleRemove()" style="margin-left: 20px"><i class="el-icon-delete"></i></span>
                        </div>
                    </div>

                    <div v-if="!formData.imgs">
                        <el-upload
                                :action="$Url"
                                list-type="picture-card"
                                :headers="headers"
                                :multiple="false"
                                :on-success="handleLogoSuccess"
                                :on-error="handleLogoError"
                                :show-file-list="false">

                            <i class="el-icon-plus"></i>
                        </el-upload

                        >
                    </div>
                  <!--<el-upload-->
                  <!--style="display: flex;"-->
                   <!--:action="$Url"-->
                    <!--list-type="picture-card"-->
                    <!--:headers="headers"-->
                    <!--:on-preview="handlePictureCardPreview"-->
                    <!--:on-remove="handleRemove"-->
                    <!--:multiple="false"-->
                    <!--:file-list="fileList"-->
                    <!--:on-success="handleLogoSuccess"-->
                    <!--:on-error="handleLogoError">-->
            <!---->
                    <!--<i class="el-icon-plus"></i>-->
                  <!--</el-upload>-->
                  <el-dialog :visible.sync="dialogVisible">
                    <img width="100%" :src="dialogImageUrl" alt="">
                  </el-dialog>
                </el-form-item>
            </el-form>
        <div class="bus-btn">
          <el-button @click="submitForm('formData')">保存</el-button>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible">
      <img :src="dialogImageUrl" alt="" style="max-height:550px;max-width: 100%;margin: 0 auto;display: block;"/>
    </el-dialog>
  </div>
</template>

<script>
import {
  productTypelist,
  productDetails,
  productHandle,
  uploadFile,
  addproduct,
  editproduct,
  delproduct,
} from "@/api/api";
import top from "../components/top.vue"; //头部
import navMenu from "../components/navMenu.vue"; //左侧步骤条
// import wangEditor from "@/components/wangEditor"; // 编辑器
export default {
  components: { top, navMenu },
  name: "createProduct",
  data() {
    return {
      countryOptionsList:[],
      optionProps:{
        value: "id",
        label: "name_cn",
        children: "children",
    },
    dictData:{},
      lists:[],
      menuOptions:[],
      formData:{
        id:'',
        ex_company_name: '',
        imgs: '',
        name_cn: '',
        name_en: '',
        model: '',
        manufacturer: '',
        country_area: '',
        show_type: 'BCEIA2019首发新品',
        contacts: '',
        mobile: '',
        email: '',
        purpose: '',
        performance: '',
        iscurrent: '是',
        ontop: "否",
        is_show:'是',
        company_long_id:'',
        company_name:'',
        type_1:'',
        type_2:'',
        type_3:'',
        types: [],
    
  },
      loading: false,
      active: 1,
      ids: 0,
      company: "",
      ruleForm: {
        goodsName: "", //产品名称
        product_type: "", //产品类型
        price: "", // 价格
        imgs: [], // 产品图片
        introduction: "", // 详细内容
        status: "1", //状态
      },
      formRules: {
         ex_company_name: [{
              required: true,
              message: '请选择企业名称（中文）',
              trigger: ['blur','change']
          }],
          types: [{
              required: true,
              message: '请选择产品分类',
              trigger: ['blur','change']
          }],
          imgs: [{
              required: true,
              message: '请上传产品图片',
              trigger: ['blur','change']
          }],
          name_cn: [{
              required: true,
              message: '请输入产品名称中文',
              trigger: ['blur','change']
          }],
          model: [{
              required: true,
              message: '请输入型号',
              trigger: ['blur','change']
          }],
          manufacturer:[{
              required: true,
              message: '请输入制造商',
              trigger: ['blur','change']
          }],
          purpose:[{
              required: true,
              message: '请输入产品用途',
              trigger: ['blur','change']
          }],
            performance:[{
              required: true,
              message: '请输入产品性能指标',
              trigger: ['blur','change']
          }],
      },
      isClear: false, //设置为true的时候，这个可以用this.wangEditorDetail=''来替代
      wangEditorDetail: "",
      options: [],
      fileList: [],
      headers: {},
      fileLength: 0,
      dialogVisible: false,
      dialogImageUrl: "",
      locationdata:[],
      show_type:[],
      userdata:{},
      mark:''
    };
  },
  mounted() {
     this.userdata = JSON.parse(localStorage.getItem("userdata"));
    this.locationdata = JSON.parse(localStorage.getItem("locationdata"));
    this.show_type = JSON.parse(localStorage.getItem("dictdata")).show_type;
    let stepMenuList = JSON.parse(localStorage.getItem("menu"));
    this.stepMenuList = stepMenuList;

    var index = stepMenuList.findIndex(function (item) {
      return item.link_url == "/conference";
    });
    this.active = index;
    this.mark=this.$route.query.mark;
    let token = localStorage.getItem("token");
    // this.company = userdata.datainfo.companyName;
    this.headers = {
      token:token,
    };
    //产品分类
    if (this.$route.query.id) {
      this.formData.id = this.$route.query.id;
      this.getDetails(this.formData.id);
    }
    this.productTypelist()
  },
  created() {},
  methods: {
    productTypelist(){
      productTypelist({}).then(res=>{
        if(res.code == 1){
          this.menuOptions=res.data.lists;
        }

      }).catch(err=>{
        console.log(err)
      })
    },
    handleSearch(val){
    // formData.ex_company_name = val;
    // if(val){
    //     queryParams.name_cn = val;
    //     getLists();
    // }
    
} ,
    // logo上传成功
    handleLogoSuccess(resData, file, fileList) {
      if (resData.code === 1) {
          this.formData.imgs=resData.data.url


      }
    },
    // logo上传失败
    handleLogoError(err, file, fileList) {
      this.$message.error(err.message);
    },
    //预览图片
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file;
      this.dialogVisible = true;
    },
    // 产品详情
    getDetails(product_long_id) {
      let data = this.$qs.stringify({
        product_long_id,
      });
      this.loading = true;
      productDetails(data).then((res) => {
          this.loading = false;
          if (res.code == 1) {
            let { data } = res;
            this.formData.name_cn=data.name_cn?data.name_cn:'';
            this.formData.name_en=data.name_en?data.name_en:'';
            this.formData.model=data.model?data.model:'';
            this.formData.manufacturer=data.manufacturer?data.manufacturer:'';
            this.formData.mobile=data.mobile?data.mobile:'';
            this.formData.contacts=data.contacts?data.contacts:'';
            this.formData.show_type=data.show_type?data.show_type:'';
            this.formData.email=data.email?data.email:'';
            this.formData.purpose=data.purpose?data.purpose:'';
            this.formData.performance=data.performance?data.performance:'';
            this.formData.product_long_id=data.product_long_id?data.product_long_id:'';
              if(data.country_area){
                  this.formData.country_area = data.country_area.split('-').join(',').split(',');
              }
              if(data.imgs){
                  this.formData.imgs=data.imgs;
              }
            this.formData.types=[]
            if(data.type_1){this.formData.types.push(Number(data.type_1))}
            if(data.type_2){this.formData.types.push(Number(data.type_2))}
            if(data.type_3){this.formData.types.push(Number(data.type_3))}
          }
        })
        .catch((err) => {});
    },
    handleRemove(file, fileList) {
      this.formData.imgs=""
    },
 
    // 返回
    goBack() {
      this.$router.back();
    },
    //滑动到错误对应位置
    scrollToFormError() {
      // 获取第一个校验错误的元素
      const element = document.querySelectorAll(".el-form-item__error")[0];
      // 滚动到错误元素对应位置
      element.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    },
    // 保存
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
           
          let data = this.formData;
          data.mark=this.mark;
          if(data.types.length>0){
            if(data.types[0]){data.type_1=data.types[0]}else{data.type_1=""}
            if(data.types[1]){data.type_2=data.types[1]}else{data.type_2=""}
            if(data.types[2]){data.type_3=data.types[2]}else{data.type_3=""}  
        }
          if(data.id){//编辑
               this.editproduct(data)
          }else{//新增
              this.addproduct(data)
          }
        
        } else {
          let that = this;
          that.$nextTick(() => {
            //加个定时器，有可能监测不到页面变化
            let timer = setTimeout(function () {
              that.scrollToFormError();
              clearTimeout(timer);
            }, 200);
          });
        }
      });
    },
        // //提交审核
        addproduct(data) {
          this.loading = true;
          addproduct(data).then((res) => {
          this.loading = false;
          if (res.code == 1) {
            this.$message.success(res.msg);
            // 返回上一页
            setTimeout(() => {
              this.goBack();
            }, 1000);
          } else {
            this.$message.warning(res.message);
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    // //提交审核
    editproduct(data) {
    this.loading = true;
    editproduct(data).then((res) => {
        this.loading = false;
        if (res.code == 1) {
          this.$message.success(res.msg);
          // 返回上一页
          setTimeout(() => {
            this.goBack();
          }, 1000);
        } else {
          this.$message.warning(res.message);
        }
      })
      .catch((err) => {
        this.loading = false;
      });
  },
    
  },
};
</script>

<style lang="scss" scoped>
    .image {
        width: 148px;
        height: 148px;
        border-radius: 6px;
        position: relative;
        /deep/ .el-image{
            width: 148px;
            height: 148px;
        }
        .upload-span {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba($color: #000, $alpha: 0.4);
            display: flex;
            align-items: center;
            justify-content: center;
            opacity: 0;
            transition: all 0.1s;
            .upload-icon {
                color: #fff;
                font-size: 22px;
            }
        }
        &:hover {
            .upload-span {
                opacity: 1;
            }
        }
    }
/deep/ .el-upload--picture-card{
  width: 146px;
  height: 146px;
}
/deep/ .el-upload{
  display: flex;
  justify-content: center;
  align-items: center;
}
.form{
  display: flex;
    flex-wrap: wrap;
    margin-bottom: 100px;
    width: 100%;
    background: #fff;
    padding: 40px;
    box-sizing: border-box
}
.form .el-form-item{
    width: 45%;
    margin-right: 60px;
}
.content {
  padding-bottom: 40px;
  .main-title {
    margin-top: 30px;
    margin-bottom: 40px;
  }
  .create-title {
    font-size: 22px;
    color: #646889;
    margin: 8px 0 50px;
  }
  .bus-ruleForm {
    display: flex;
    flex-wrap: wrap;
    .el-form-item {
      width: 37%;
      margin-right: 80px;
      .el-input__inner {
        width: 100% !important;
        height: 50px;
        line-height: 50px;
      }
    }
    .form-width {
      width: 80%;
    }
  }
  .bus-btn {
    text-align: center;
    .el-button {
      position: inherit;
      transform: translateX(0);
    }
  }
}
.hide-box /deep/ .el-upload--picture-card {
  display: none;
}
</style>
<style lang="scss">
.bus-ruleForm .el-form-item {
  .el-form-item__label {
    font-size: 15px;
  }
  .el-select {
    width: 100%;
  }

  .el-input__inner {
    width: 100% !important;
    height: 38px;
    font-size: 12px;
    line-height: 38px;
    border-radius: 6px;
    border-color: #e0e0e0;
  }
}
.el-upload-list__item {
  display: flex !important;
 
  align-items: center;
  justify-content: center;
  transition: none !important;
  -webkit-transition: nonne !important;
}
.el-upload-list__item img {
  max-width: 148px;
  max-height: 148px;
  width: auto !important;
  height: auto !important;
}
.el-upload-list__item-name {
  transition: none !important;
  -webkit-transition: nonne !important;
}
.upload-demo,.el-upload-list{
  display: flex;
  flex-wrap: wrap !important;
}
.el-upload--picture-card {
  width: 384px;
  height: 152px;
  line-height: 20px;
  border-radius: 8px;
  .el-icon-tickets {
    // font-size: 55px;
    font-size: 40px;
    color: #1677ff;
    // margin: 25px 0 16px;
     margin: 15px 0 4px;
    line-height: 50px;
  }
  .el-upload__text {
    height: auto;
    color: #999;
    font-size: 14px;
    line-height: 24px;
  }
}
@media only screen and (max-width: 767px) {

  .el-form-item {
      width:100% !important;
      margin-right: 0px !important;
      margin-bottom: 0px !important;
  }
  .el-input__inner {
        width: 100% !important;
        margin: 20px 0;
    }
}
</style>